var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRBlanc = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PICTO",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M647.6,622.77c-2.91-5.2-.34-11.78,5.34-13.59,97.94-31.25,162.12-115.06,162.12-222.03,0-148.32-107.56-243.42-268.33-243.42h-273.58c-5.23,0-9.46,4.24-9.46,9.46v225.06c0,5.23,4.24,9.46,9.46,9.46h79.57c5.23,0,9.46-4.24,9.46-9.46v-134.49c0-5.23,4.24-9.46,9.46-9.46h168.29c105.29,0,174.36,60.01,174.36,152.84s-69.06,153.98-175.49,153.98h-167.16c-5.23,0-9.46,4.24-9.46,9.46v71.65c0,5.23,4.24,9.46,9.46,9.46h163.88c3.42,0,6.58,1.85,8.25,4.83l165.54,294.89c1.67,2.98,4.83,4.83,8.25,4.83h89.28c7.23,0,11.79-7.78,8.26-14.08l-167.5-299.41Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRBlanc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/R_blanc.fd10b2fecfcb4f02b4765fbc2a0a768f.svg";